export var mapClientPreviewObjectToClient = function (object) {
    return {
        id: object.id,
        contractNumber: object.contractNumber,
        contractDate: null,
        showDetails: false,
        createdAt: object.created_at,
        // russianLegalEntity: object.russianLegalEntity,
    };
};
